import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'price-promotion',
    template: `<div class="promotion-box" *ngIf="hasPromotion">
                    <span class="promotion-text">{{title}}</span>
                </div>`,
    styles: [`
        .promotion-text {
            color: #FFFFFF;
            font-weight: bold;
            font-size: 12px;
            line-height: 22px;
        }
        @media screen and (max-width: 1023px){
            .promotion-text {
                font-size: 12px;
            }
        }`]
})
export class PricePromotionComponent implements OnChanges {
    @Input() promotion: Promotion;
    @Input() price: number;
    @Input() typeText: boolean;
    @Output() onChangePrices: EventEmitter<any> = new EventEmitter();
    public title: string = "";
    public discount: number;
    public highPrice: number;
    public hasPromotion: boolean = false;
    constructor(private translate:TranslateService) { }

    ngOnChanges() {
        if (this.promotion && this.promotion.promotionType === "RETAIL") {
            this.checkHighPrice(this.promotion.value, this.price);
            this.createDiscount(this.promotion.value);
        }
        if(this.typeText){
            this.translate.get("SAVE_UP_TO").subscribe(res => {
                this.title = `${res} ${this.discount}%`;
            });
        }else {
            this.translate.get(["SAVE","VS_RETAIL"]).subscribe(res => {
                this.title = `${res.SAVE} ${this.discount}% ${res.VS_RETAIL}`;
            });
        }
    }

    checkHighPrice(rate: number, price: number) {
        if (rate > 0 && rate < 100) {
            this.highPrice = (price * 100)/(100 - rate);
            this.onChangePrices.emit({ highPrice: this.highPrice });
            this.hasPromotion = true;
        }
    };

    createDiscount(discount: number) {
        if(discount && discount > 0){
            this.discount = discount;
        }
    };
}

export class Promotion {
    public id: number;
    public promotionType: string;
    public startDate: Date;
    public endDate: Date;
    public fixed: number;
    public value: number; 
}